module.exports = __webpack_public_path__ + "static/Canela-MediumItalic-b226cb27266c96b5690289a221bf99ad.otf";